import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrderListComponent } from './order-list/order-list.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'order-detail',
        component: OrderDetailComponent,
        data: {
          title: "Order Detail",
          breadcrumb: "Order Detail"
        }
      },
      {
        path: 'order-list',
        component: OrderListComponent,
        data: {
          title: "Order List",
          breadcrumb: "Order List"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderRoutingModule { }
